import { render, staticRenderFns } from "./FileConfig.vue?vue&type=template&id=645fc4c4"
import script from "./FileConfig.vue?vue&type=script&lang=js"
export * from "./FileConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports